import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Box, Image } from '@bonusly/design-system';
import { useCurrentCompany } from '@bonusly/who-am-i';

import logo from '../../assets/images/bonusly-logo.png';
import { AppPath } from '../../config/router';

export const CompanyLogo: FC = () => {
	const company = useCurrentCompany();
	const { t } = useTranslation('vertical_navbar');

	return (
		<Box as={Link} id="primary-nav-logo" data-testid="company-logo" to={AppPath.Home} px={6} py={3.5} display="block">
			<Image
				data-testid="logo-image"
				alt={t('admin_menu.company_logo', { name: 'Bonusly' })}
				h="full"
				objectFit="contain"
				src={logo}
				{...(company?.logo_url && {
					alt: t('admin_menu.company_logo', { name: company.name }),
					src: company.logo_url,
				})}
			/>
		</Box>
	);
};
